import React, { useMemo } from 'react';
import { FiBarChart2, FiBriefcase, FiUsers, FiHelpCircle } from 'react-icons/fi';
import './AdminSidebar.css';

const DEFAULT_SECTIONS = [
  {
    label: 'Resumen',
    items: [{ key: 'overview', label: 'Resumen general', icon: FiBarChart2 }],
  },
  {
    label: 'Operaciones',
    items: [
      { key: 'companies', label: 'Empresas', icon: FiBriefcase },
      { key: 'users', label: 'Usuarios', icon: FiUsers },
    ],
  },
  {
    label: 'Soporte',
    items: [{ key: 'support', label: 'Soporte', icon: FiHelpCircle }],
  },
];

const normalizeSections = sections =>
  Array.isArray(sections) && sections.length > 0
    ? sections.map(section => ({
        label: section.label,
        items: Array.isArray(section.items) ? section.items : [],
      }))
    : DEFAULT_SECTIONS;

export default function AdminSidebar({
  activeKey,
  onSelect,
  sections,
  heading = 'Panel administrativo',
  description = 'Gestiona la información clave de Flotte',
  activeTab,
  onChangeTab,
}) {
  const menuSections = useMemo(() => normalizeSections(sections), [sections]);
  const resolvedActiveKey = activeKey ?? activeTab ?? '';
  const handleSelect = onSelect || onChangeTab;

  return (
    <aside className="admin-dashboard-sidebar">
      <div className="sidebar-inner">
        <header className="sidebar-header">
          <span className="sidebar-kicker">Administrador</span>
          <h1 className="sidebar-title">{heading}</h1>
          {description ? <p className="sidebar-description">{description}</p> : null}
        </header>
        <nav className="sidebar-menu">
          {menuSections.map(section => (
            <div key={section.label} className="sidebar-section">
              <span className="sidebar-section-label">{section.label}</span>
              <ul className="sidebar-list">
                {section.items.map(item => {
                  const Icon = item.icon;
                  const isActive = resolvedActiveKey === item.key;
                  return (
                    <li key={item.key} className="sidebar-list-item">
                      <button
                        type="button"
                        className={`sidebar-item${isActive ? ' active sidebar-item--active' : ''}`}
                        onClick={() => handleSelect?.(item.key)}
                        aria-current={isActive ? 'page' : undefined}
                      >
                        <span className="sidebar-icon" aria-hidden="true">
                          {Icon ? <Icon /> : null}
                        </span>
                        <span className="sidebar-label">{item.label}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </nav>
      </div>
    </aside>
  );
}
